import { cloneDeep } from "lodash";
import { CLEAR_ROOM } from "../base/conference";
import { ReducerRegistry } from "../base/redux";
import { 
    REFRESH_IMAGE, 
    REMOVE_DOCUMENT, 
    SET_DOCUMENT_FILE, 
    SET_FOCUS_SHARE_DOCUMENT, 
    SET_DELETE_LINE, 
    SET_DOCUMENT_BUFFER,
    SET_CANVAS_ONE_LINE,
    SET_CANVAS_LINE,
    SET_DELETE_ONE_LINE,
    SET_DELETE_KEY_LINE
} from "./actionTypes";
import { DEFAULT_DOCUMENT, DEFAULT_INDEX } from "./constants";

const DEFAULT_STATE = {
    whiteBoard: new Map(),
    document: new Map(),
    documentFocus: { uuid: null, index: null },
    whiteFocus: { uuid: DEFAULT_DOCUMENT, index: DEFAULT_INDEX },
    arrayBufferList: new Map(),
    canvasList: new Map(),
    refresh: null,
    deleteLine: null
};

ReducerRegistry.register("features/share-document", (state = DEFAULT_STATE, action) => {
    switch (action.type) {    
        case CLEAR_ROOM: {
            return {
                whiteBoard: new Map(),
                document: new Map(),
                documentFocus: { uuid: null, index: null },
                whiteFocus: { uuid: DEFAULT_DOCUMENT, index: DEFAULT_INDEX },
                arrayBufferList: new Map(),
                canvasList: new Map(),
                refresh: null,
                deleteLine: null
            }
        } 
        
        case SET_DOCUMENT_FILE:    
            var { uuid, isWhiteBoard } = action.data;

            if (action.tempUuid) {
                state.document.delete(action.tempUuid);
            }
            if (isWhiteBoard) {
                const newDocument = _documentList(state.whiteBoard.get(uuid), action.data);
                state.whiteBoard.set(uuid, newDocument);
            } else {
                const newDocument = _documentList(state.document.get(uuid), action.data);
                state.document.set(uuid, newDocument);
            }

            if (!state.canvasList.get(uuid)) {
                state.canvasList.set(uuid, new Map());
            }

            return {
                ...state
            }

        case SET_DOCUMENT_BUFFER:
            var { uuid, buffer } = action;

            const newBuffer = _documentList(state.arrayBufferList.get(uuid), buffer);
            state.arrayBufferList.set(uuid, newBuffer);       

            return {
                ...state
            }
        
        case SET_FOCUS_SHARE_DOCUMENT: 
            var { isWhiteBoard, uuid, index } = action;

            if (isWhiteBoard) {
                state.whiteFocus = { uuid, index };
            } else {
                state.documentFocus = { uuid, index };
            }
            return {
                ...state
            }

        case SET_CANVAS_ONE_LINE:
            var list = state.canvasList.get(action.uuid);
            if (!list) break;
            var prevLine = list && list.get(action.index);

            if (prevLine) {                    
                list.set(action.index, new Map([...prevLine].concat([...action.newLine])));
            } else {
                list.set(action.index, action.newLine);
            }            
            return { 
                ...state, 
                canvasList: state.canvasList.set(action.uuid, new Map([...state.canvasList.get(action.uuid)].concat([...list])))
            };

        case SET_CANVAS_LINE:
            return { 
                ...state, 
                canvasList: state.canvasList.set(action.uuid, action.line)
            };

        case SET_DELETE_ONE_LINE:
            var list = state.canvasList.get(action.uuid);
            if (!list) break;

            var stringIndex = String(action.index);
            var canvasList = list.get(stringIndex); 
            canvasList.delete(action.deleteLine);

            return {
                ...state,
                canvasList: state.canvasList.set(action.uuid, new Map([[ stringIndex, canvasList ]]))
            }

        case SET_DELETE_KEY_LINE:
            var list = state.canvasList.get(action.uuid);
            if (!list) break;

            var stringIndex = String(action.index);
            var canvasList = list.get(stringIndex); 
            canvasList.forEach((value, key) => {
                if (key.indexOf(action.drawKey) !== -1) canvasList.delete(key);
            });

            return {
                ...state,
                canvasList: state.canvasList.set(action.uuid, new Map([[ stringIndex, canvasList ]]))
            }
        
        case SET_DELETE_LINE:
            var stringIndex = String(action.index);

            return {
                ...state,
                canvasList: state.canvasList.set(action.uuid, new Map([[ stringIndex, new Map() ]]))
            }
        
        case REFRESH_IMAGE:
            return {
                ...state,
                refresh: Date.now()
            }

        case REMOVE_DOCUMENT:
            var { uuid, isWhiteBoard } = action;

            if (isWhiteBoard) {
                state.whiteBoard.delete(uuid);
            } else {
                state.document.delete(uuid);
            }

            if (state.canvasList.has(uuid)) state.canvasList.delete(uuid);

            return { ...state };
    }
    
    return state;
});

function _documentList(state, documentList) {
    const newState = { ...state };
    
    for (const key in documentList) {        
        newState[key] = cloneDeep(documentList[key]);
    }

    return newState;
}